import FormattedHTMLMessage from 'components/FormattedHTMLMessage';
import {ManualReteachTipsStatus} from 'constants/dataEnum';
import {showLoading} from 'stores/actions/appStateAction';
import {hideTypedModal} from 'stores/actions/typedModalAction';
import {postManualReteachReturnTips} from 'stores/business/instrumentBusiness';

// eslint-disable-next-line import/prefer-default-export
export const setStatusTipsAfterManualReteach = (tipsStatus) => (dispatch, getState) => {
  const {sessionState} = getState();
  const {username} = sessionState.user;
  const returnInfo = tipsStatus === ManualReteachTipsStatus.PUT_TO_CADDY ? 'caddy' : 'waste bin';

  dispatch(
    showLoading(
      <FormattedHTMLMessage
        id="plateTypeEditorContainer.manualReteachPlate.returnTipsConfirmation.content.loading"
        values={{messageInfo: returnInfo}}
      />,
    ),
  );
  // TODO set some activity to get data into backend
  dispatch(postManualReteachReturnTips(username, tipsStatus === ManualReteachTipsStatus.PUT_TO_CADDY));
  dispatch(hideTypedModal(false));
};
